import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

import ZOOMRESTAPIENDPOINTOPTIONS from "resources/img/zoom_rest_api_endpoint_options.png";
import ZOOMSERVERSDKAUTHENTICATIONFLOW from "resources/img/zoom_server_sdk_authentication_flow.png";
import ZOOMCOMPAT from "resources/img/zoom_compat_matrix.jpg";
import SERVER_ARCHITECTURE_AND_DATA_FLOW from "resources/img/zoom_server_architecture_and_data_flow.png";
import SERVER_DEDICATE_AND_CLOUD_ARCHITECTURE from "resources/img/zoom_server_dedicated_and_cloud_architecture.png";
import SERVER_CONSOLE_AND_COMPAT from "resources/img/server-console-and-compat.png";

export default React.createClass({
  displayName: "zoom-configuration-options",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container quick-guides-pages">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="zoom-architecture-and-configuration-options">FaceTec Architecture & Configuration Options</h2>
                </div>
                <p>Learn how the FaceTec SDKs will be configured in production and how your user's data will flow through your systems.  No biometric data comes to FaceTec when your SDKs are in production with your end users.Learn how the FaceTec SDKs will be configured in production and how your user's data will flow through your systems.  No biometric data comes to FaceTec when your SDKs are in production with your end users.</p>
                <hr/>
              </section>

              <section>
                <h3 id="zoom-device-sdk-features-and-options">FaceTec Device SDK Features & Options</h3>
                <p>An overview of FaceTec Device SDK properties as they related to Liveness Check vs. Enrollment & Authentication modes.</p>
                <table width="100%">
                  <tbody>
                    <tr>
                      <th className="col-xs-3">FaceTec Device SDK Features</th>
                      <th className="col-xs-4">Face Authentication (Matching + Liveness ✓)</th>
                      <th className="col-xs-4">Liveness Check Only (No Face Matching)</th>
                    </tr>
                    <tr>
                      <td>Devices / Browsers Supported</td>
                      <td>Android/iOS, Mobile Browser, PWA & Webcam</td>
                      <td>Android/iOS, Mobile Browser, PWA & Webcam</td>
                    </tr>
                    <tr>
                      <td>Biometric Data Stored</td>
                      <td>Encrypted FaceMap Stored on Server</td>
                      <td>None, or On-Server (for Audit Trail)</td>
                    </tr>
                    <tr>
                      <td>3D Liveness Verified</td>
                      <td>Yes, On-Server</td>
                      <td>Yes, On-Server</td>
                    </tr>
                    <tr>
                      <td>3D Face Match to Govt. Photo ID</td>
                      <td>Yes, with <span><a href="https://www.facetec.com/FaceTec_Identity_Check.pdf" target="_blank">Photo ID Identity Check</a></span></td>
                      <td>Yes, with <span><a href="https://www.facetec.com/FaceTec_Identity_Check.pdf" target="_blank">Photo ID Identity Check</a></span></td>
                    </tr>
                    <tr>
                      <td>3D Face Matching</td>
                      <td>On-Server - 1:1 & 1:N (1/4.2M FAR @ &lt;1% FRR)</td>
                      <td>Not Applicable</td>
                    </tr>
                    <tr>
                      <td>SDK Download Size</td>
                      <td>iOS/Android: 6.7MB  &  Browser: 3MB</td>
                      <td>iOS/Android: 6.7MB  &  Browser: 3MB</td>
                    </tr>
                    <tr>
                      <td>Transmitted 3D FaceMap Size</td>
                      <td>~300KB</td>
                      <td>~300KB</td>
                    </tr>
                    <tr>
                      <td>Age Check (Anonymous)</td>
                      <td>Yes, Age Check on 3D FaceMaps & 2D Images</td>
                      <td>Yes, Age Check on 3D FaceMaps & 2D Images</td>
                    </tr>
                  </tbody>
                </table>
                <p></p>
                <p></p>
                <hr />
              </section>

              <section>
                <h3 id="zoom-server-sdk-and-api-options">FaceTec Server SDK & API Options</h3>
                <p>An overview of FaceTec Server SDK properties when you have a production instance vs. when you are testing against the FaceTec Testing API.</p>
                <table>
                  <tbody>
                    <tr>
                      <th className="col-xs-3">FaceTec Server SDK Access</th>
                      <th className="col-xs-4">FaceTec Testing API</th>
                      <th className="col-xs-4">Customer Hosted Server SDK/API</th>
                    </tr>
                    <tr>
                      <td>At Rest/In Transit Data</td>
                      <td>Encrypted</td>
                      <td>Encrypted</td>
                    </tr>
                    <tr>
                      <td>Biometric Storage</td>
                      <td>FaceTec Testing Cloud (AWS)</td>
                      <td>Customer’s Private Server / Cloud or User Device</td>
                    </tr>
                    <tr>
                      <td>Server/Cloud Software Required</td>
                      <td>None (all operations REST API based)</td>
                      <td>FaceTec Server SDK (provides private REST API)</td>
                    </tr>
                    <tr>
                      <td>1:N Duplicate Check for Onboarding</td>
                      <td>For Testing/POC Only</td>
                      <td>Yes, new user 3D FaceMaps can be checked for dupes</td>
                    </tr>
                    <tr>
                      <td>Migration To The Other API</td>
                      <td>Yes, move from FaceTec’s Managed Testing API to your own Server SDK/API w/ a Device SDK Update</td>
                      <td>Not Applicable</td>
                    </tr>
                    <tr>
                      <td>Server Sample Code & Demo Apps</td>
                      <td>Yes, via REST API</td>
                      <td>Yes, Java, Docker</td>
                    </tr>
                    <tr>
                      <td>Startup Effort</td>
                      <td>Sample apps pre-configured for immediate testing</td>
                      <td>FaceTec Server SDK deploys in minutes</td>
                    </tr>
                    <tr>
                      <td>Pricing Model</td>
                      <td>For Initial Setup & Testing Only</td>
                      <td>Billed Per Liveness Check Session</td>
                    </tr>
                  </tbody>
                </table>
                <p></p>
                <p></p>
                <hr />
              </section>

              <section>
                <h3 id="standard-vs-custom">FaceTec Standard Server vs. Custom Server SDKs</h3>
                <p>Feature comparison of Standard Server and Custom Server SDKs.</p>
                <table>
                  <tbody>
                    <tr>
                      <th className="col-xs-3">Server SDK Feature</th>
                      <th className="col-xs-4">Standard Server</th>
                      <th className="col-xs-4">Custom Server SDKs</th>
                    </tr>
                    <tr>
                      <td>Server Dashboard</td>
                      <td>Available by Default</td>
                      <td>Not Possible.  Customer must implement their own.</td>
                    </tr>
                    <tr>
                      <td>Databases Supported</td>
                      <td>MongoDB (planned support for SQL, Dynamo, RDS/Aurora, and more)</td>
                      <td>Any. Customers must configure (examples provided)</td>
                    </tr>
                    <tr>
                      <td>Databases Integration</td>
                      <td>Database Setup Only</td>
                      <td>Customer must Setup Database, develop, and support all code that interfaces with Database</td>
                    </tr>
                    <tr>
                      <td>Startup Effort</td>
                      <td>1 Config File with several properties</td>
                      <td>Initial development deploys in minutes, Production must be customized and configured</td>
                    </tr>
                    <tr>
                      <td>Overall Integration Style</td>
                      <td>Prescriptive behavior.  All processing performed via REST.</td>
                      <td>Completely custom.  Sample REST Server Core and Docker Container provided</td>
                    </tr>
                    <tr>
                      <td>Coding Required</td>
                      <td>Your favorite server-side language to call Standard Server REST APIs</td>
                      <td>Customize FaceTec Server SDK using Java code, then call via REST or other custom methods</td>
                    </tr>
                    <tr>
                      <td>Code Access</td>
                      <td>Closed-source.</td>
                      <td>Open-source code provided.</td>
                    </tr>
                    <tr>
                      <td>Uses Server Core</td>
                      <td>Yes</td>
                      <td>Yes</td>
                    </tr>
                    <tr>
                      <td>Differences in Liveness Detection or Matching Accuracy</td>
                      <td>No, uses same Server Core Library</td>
                      <td>No, uses same Server Core Library</td>
                    </tr>
                  </tbody>
                </table>
                <p></p>
                <p></p>
                <hr />
              </section>

              <section>
                <h3 id="zoom-architecture-and-data-flow">FaceTec Platform Architecture & Data Flow</h3>
                <p>Learn about the FaceTec production integration architectural components and how data will flow through your systems.</p>
                <p style={{textAlign:'center'}}><img src={SERVER_ARCHITECTURE_AND_DATA_FLOW}  width="98%"  style={{maxWidth: '1500px'}} /></p>
                <p><strong>High-level notes:</strong></p>
                <ul>
                  <li><p>The FaceTec Device SDKs are integrated into your apps & webpages.</p></li>
                  <li><p>You 100% control over all communications from the client devices to your server.</p></li>
                  <li><p>3D FaceMaps are stored in your database on your servers, not FaceTec's.</p></li>
                  <li><p>No Biometric Data or User PII is ever sent to FaceTec by the FaceTec Server SDK, only .txt Logs over SFTP.</p></li>
                  <li><p>To maintain anonymity after Liveness Checks and Age Checks, FaceMaps can be immediately deleted.</p></li>
                  <li><p>You may use any Database you choose to store the 3D FaceMap data, but MongoDB is required for the FaceTec Server Dashboard.</p></li>
                </ul>
                <hr />
              </section>

              <section>
              <h3 id="hardware">Customer Server/Cloud Hardware Components</h3>
              <p>When in Production, you will be running FaceTec's Server SDK on YOUR OWN Server/Cloud, and no biometric data is transmitted to FaceTec. Below is a high-level overview of the components that you will need to run the FaceTec Server SDK on your Server/Cloud.</p>
              <p style={{textAlign:'center'}}><img src={SERVER_DEDICATE_AND_CLOUD_ARCHITECTURE}  width="98%"  style={{maxWidth: '1500px'}} /></p>
              <p><strong>Benchmark Performance  (baseline):  Hardware cluster of 4 Servers, each running 8-core Intel Xeon Platinum 8000 Series CPUs.</strong></p>
              <ul>
                <li><p>1.7 million Liveness Checks per day (20 per second, in 3D FaceMap Prepare Mode.).</p></li>
                <li><p>1:N scan for duplicates 3D FaceMaps in a Database of 1,000,000 can be performed in under 1 second.</p></li>
                <li><p>On AWS/Google the cost for 4 8-core machines is ~$4,000-$5,200 annually.</p></li>
                <li><p>Other additional costs to consider: FaceMap storage, database for transaction logs and analytics.</p></li>
              </ul>
              </section>

              <section id="main">
                <p><strong>Calculating Your Infrastructure Requirements:</strong></p>
                <ul>
                  <li><p>To double the requests/sec OR the geographic regions multiply required hardware by 2.</p></li>
                  <li><p>To ensure resiliency to load spikes, it is standard industry practice to multiply all hardware by 3.</p></li>
                  <li><p>To handle more than 1.5x peak load, we recommend you perform your own testing and analysis to determine additional hardware requirements.</p></li>
                </ul>
                <hr />
              </section>

              <section>
                <h3 id="zoom-rest-api-endpoint-options">FaceTec REST API: Endpoint Options</h3>
                <p>A quick look at how the Device SDKs connect to FaceTec Server SDKs when in development and production.</p>
                <p style={{textAlign: "center"}}><img src={ZOOMRESTAPIENDPOINTOPTIONS}  width="85%" style={{maxWidth: '1000px'}} /></p>
                <p></p>
                <hr />
              </section>

              <section>
                <h3 id="zoom-server-sdk-authentication-flow">FaceTec Server SDK: Authentication Flow</h3>
                <p>A look at how data flows when performing Authentication with FaceTec.</p>
                <p style={{textAlign: "center"}}><img src={ZOOMSERVERSDKAUTHENTICATIONFLOW}  width="85%" style={{maxWidth: '1300px'}} /></p>
                <p></p>
              </section>

              <section>
                <h3 id="console-compatibility">FaceTec Server Dashboard & Compatibility</h3>
                <p>The FaceTec Server Dashboard (<a href="https://www.youtube.com/watch?v=hDGL3ie7UbY&feature=youtu.be" target="_blank">Video Link Here</a>) shows FaceTec Usage from your users as they perform Liveness Checks, Enrollments, Authentications, Photo ID Matches, and Age Checks.  <Link to="/server-dashboard-demo">Use The Dashboard Demo Here</Link>.</p>
                <br />
                <br />
                <p style={{textAlign: "center"}}><img src={SERVER_CONSOLE_AND_COMPAT}  width="85%" style={{maxWidth: '1300px'}} /></p>
                <p>More information about FaceTec Server Dashboard:</p>
                <ul>
                  <li><p>Customer must use Standard Server.</p></li>
                  <li><p>Hosted in Customer's Cloud.</p></li>
                  <li><p>Customer is responsible for securing the Dashboard Web App (internal access controls, whitelisting, etc.).</p></li>
                  <li><p>As a closed-source Web App, FaceTec provides updates & improvements.</p></li>
                  <li><p>Must use FaceTec Standard Server SDK.</p></li>
                  <li><p>Databases supported now:  MongoDB.</p></li>
                  <li><p>Planned database support:  SQL, Dynamo, RDS/Aurora, and more.</p></li>
                </ul>
              </section>

              <SDKSidebar menuType="main" title="FaceTec Configuration Options"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-configuration-options.jsx